import * as auth_actions from '../../../common/js/auth/auth-actions';
import * as types from '../actions/types';
import {takeEvery, select, put, call} from "redux-saga/effects";
import {loadConstants} from "../actions/actions";
import {LOCATION_CHANGE} from 'connected-react-router';
import {NOTIFICATIONS_DISMISS_SUCCESS, syncNotifications} from "../../../common/js/notifications/notifications-actions";

function* loadConstantsSaga(action) {
    yield put(loadConstants());
}

function* syncNotificationsSaga(action) {
    const state = yield select();
    if (state.auth.isAuthenticated) {
        yield put(syncNotifications());
    }
}

export function* candidateRootSaga() {
    yield takeEvery(auth_actions.AUTH_INIT_SUCCESS, loadConstantsSaga);
    yield takeEvery(auth_actions.AUTH_INIT_SUCCESS, syncNotificationsSaga);

    yield takeEvery(auth_actions.AUTH_SIGN_IN_SUCCESS, loadConstantsSaga);
    yield takeEvery(auth_actions.AUTH_SIGN_IN_SUCCESS, syncNotificationsSaga);

    yield takeEvery(types.LANGUAGE_SET_SUCCESS, loadConstantsSaga);

    yield takeEvery(LOCATION_CHANGE, syncNotificationsSaga);

    yield takeEvery(NOTIFICATIONS_DISMISS_SUCCESS, syncNotificationsSaga);
}
